import { Button } from '@mui/material'
import { INavBarButton } from '../../interfaces/layout'
import { useHistory } from 'react-router-dom'
import { newThemeObject } from '../../newTheme'
import { tokens } from '../../styles/tokens'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import React from 'react'
import { useCurrentPage } from '../../hooks/useCurrentPage'

interface Props {
  button: INavBarButton
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 700,
    background: tokens.color.white,
    justifyContent: 'left',
    padding: '10px',
    gap: '5px',
    borderRadius: newThemeObject.roundness.basic,
    margin: 10,
  },
  title: {
    fontSize: '1.3rem',
    fontWeight: '600',
    color: newThemeObject.palette.main.primary,
    margin: 0,
    marginLeft: theme.spacing(4),
  },
  client: {
    fontWeight: '600',
    fontSize: '0.9rem',
    color: tokens.color.neutral[900],
    margin: 0,
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    textWrap: 'wrap',
    maxWidth: '80%',
  },
  active: {
    background: tokens.color.primary[50],
    color: tokens.color.primary[700],
    boxShadow: `inset 3px 0 0 ${tokens.color.primary[700]}`,
    '& p': {
      fontWeight: 600,
    },
  },
  nonActive: {
    background: 'transparent',
    color: tokens.color.neutral[600],
  },
  button: {
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    justifyContent: 'left',
    padding: '10px',
    borderRadius: newThemeObject.roundness.small,
    alignItems: 'center',
    transition: `background-color ${tokens.transition.fast}, color ${tokens.transition.fast}`,
    '&:hover': {
      background: tokens.color.neutral[100],
      color: tokens.color.neutral[900],
    }
  },
  iconContainer: {
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    minWidth: '28px',
    minHeight: '28px',
    boxSizing: 'border-box',
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.color.primary[50],
    boxShadow: tokens.shadow.sm,
  },
  icon: {
    fontSize: '1.05rem',
    color: tokens.color.primary[600],
  },
  subButton: {
    paddingLeft: '30px',
  },
  subIconContainer: {
    minWidth: '22px',
    minHeight: '22px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  subIcon: {
    fontSize: '0.9rem',
    color: tokens.color.neutral[400],
  },
  text: {
    textAlign: 'left',
    margin: 0,
  },
  // agregát „Všechna portfolia" není portfolio, ale přehled — decentní odlišení
  aggregateText: {
    fontStyle: 'italic',
    color: tokens.color.neutral[500],
  },
  aggregateIcon: {
    color: tokens.color.neutral[500],
  },
  wannaBeButtonWrapper: {
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    justifyContent: 'left',
    alignItems: 'center',
    padding: '16px 10px 8px',
  },
  sectionIconContainer: {
    flexShrink: 0,
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
  },
  sectionIcon: {
    fontSize: '18px',
    color: tokens.color.neutral[400],
  },
  sectionText: {
    margin: 0,
    textAlign: 'left',
    fontSize: '0.6875rem',
    fontWeight: tokens.font.weight.semibold,
    letterSpacing: '0.04em',
    color: tokens.color.neutral[400],
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}))

export const NavBarButton: React.FC<Props> = ({ button }: Props) => {
  const classes = useStyles()
  const history = useHistory()
  const curr = useCurrentPage()

  const onNavButtonClick = (path: string) => () => {
    history.push(path)
  }

  let activClass = curr === button.link ? classes.active : classes.nonActive
  if (
    curr.split('/')[1] === 'client-detail' &&
    !curr.split('/')[3] &&
    button.link?.startsWith('/client-detail') &&
    button.link?.endsWith('0')
  ) {
    activClass = classes.active
  }
  return (
    <>
      {
        ( button.link || button.function ) && 
        <Button
          onClick={button.link ? onNavButtonClick(button.link) : button.function}
          className={classNames(classes.button, activClass, { [classes.subButton]: button.sub })}
          id={button.id}
        >
          {button.icon && (
            <span className={classNames(classes.iconContainer, { [classes.subIconContainer]: button.sub })}>
              {React.cloneElement(button.icon, { className: classNames(classes.icon, { [classes.subIcon]: button.sub, [classes.aggregateIcon]: button.aggregate }) })}
            </span>
          )}
          <p style={button.icon ? { fontSize: button.sub ? 11 : 12 } : { fontSize: 11, marginLeft: 20 }} className={classNames(classes.text, { [classes.aggregateText]: button.aggregate })}>
            {button.text}
          </p>
        </Button>
      }
      {
        !button.link && !button.function &&
        <div className={classes.wannaBeButtonWrapper}>
          {button.icon && (
            <span className={classes.sectionIconContainer}>{React.cloneElement(button.icon, { className: classes.sectionIcon })}</span>
          )}
          <p className={classes.sectionText}>{button.text.toLocaleUpperCase()}:</p>
        </div>
      }
    </>
  )
}
